// Pure class composition for <Badge> — variant × tone × size, same house grammar as Button
// (color via the .rc-tone-* slots in tones.css). No `ghost` variant: an invisible badge is
// meaningless. Split out so it is unit-testable without the CSS side-effect.
import { cn } from "./cn";
import type { Tone } from "./tone";

export type BadgeVariant = "solid" | "soft" | "outline";
export type BadgeTone = Tone;
export type BadgeSize = "sm" | "md" | "lg";

export function badgeClass(
  variant: BadgeVariant,
  tone: BadgeTone,
  size: BadgeSize,
  extra?: string,
): string {
  return cn("rc-badge", `rc-badge--${variant}`, `rc-tone-${tone}`, `rc-badge--${size}`, extra);
}
